import { Component, OnInit, ViewChild } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

@Component({
  selector: 'app-gestionclients',
  templateUrl: './gestionclients.component.html',
  styleUrls: ['./gestionclients.component.css']
})
export class GestionclientsComponent implements OnInit {
  @ViewChild('newPersonne') personneModal;
  @ViewChild('newDepot') depotModal;
  @ViewChild('newAchat') achatModal;
  @ViewChild('newSolde') soldeModal;

  private clientCourant: object;

  constructor(private appService: AppService, private modalService: NgbModal) { }

  ngOnInit() {
    this.clientCourant = this.appService.clients[0];
  }

  search = (text$: Observable<string>) =>
    text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => term.length < 1 ? []
    : this.appService.clients.filter(v => v.nom.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
  );

  formatter = (x: { nom: string, prenom: string }) => x.nom + " " + x.prenom;

  deposerArticles() {
    this.depotModal.initDepotArticle(this.clientCourant);
    this.modalService.open(this.appService.depotModal, { windowClass: 'xlModal backgroundModal', backdrop: 'static', keyboard: false });
  }

  acheterArticles() {
    this.achatModal.initAchatArticles(this.clientCourant);
    this.modalService.open(this.appService.achatModal, { windowClass: 'xlModal backgroundModal', backdrop: 'static', keyboard: false });
  }

  solderDepot() {
    this.soldeModal.initSoldeDepot(this.clientCourant);
    this.modalService.open(this.appService.soldeModal, { windowClass: 'xlModal backgroundModal', backdrop: 'static', keyboard: false });
  }

  ajouterPersonne() {
    this.modalService.open(this.appService.personneModal, { size: 'lg', backdrop: 'static', keyboard: false });
  }

}
